export default __webpack_public_path__ + "static/media/i46logo.c6a9313c.png";